// Multiple Choice Question Component
// Handles user interaction for multiple choice trivia questions
// Follows the Section, Component & Manager System architecture

import React from 'react';

export function MultipleChoiceQuestion({
  trivia,
  selectedAnswer,
  showResults,
  onAnswerSelect,
  onSubmitAnswer,
  disabled = false
}) {


  const options = trivia.questionData?.options || [];

  return (
    <div className="learn-trivia-options">
      <div className="mc-options-grid">
        {options.map((option, index) => {
          const isSelected = selectedAnswer === index;
          const isCorrect = showResults && index === trivia.questionData.correctAnswer;
          const isIncorrect = showResults && isSelected && index !== trivia.questionData.correctAnswer;

          return (
            <div
              key={index}
              className={`mc-option-card ${
                isSelected ? 'selected' : ''
              } ${
                isCorrect ? 'correct' :
                isIncorrect ? 'incorrect' :
                showResults ? 'disabled' : ''
              }`}
              onClick={async () => {
                if (showResults || disabled) return;
                // For single-select questions, selecting immediately submits
                onAnswerSelect(index); // Update selection state first
                await onSubmitAnswer(index);
              }}
            >
              <div className="mc-option-header">
                <div className="mc-option-indicator">
                  {String.fromCharCode(65 + index)}
                </div>
              </div>

              <div className="mc-option-content">
                <p className="mc-option-text">{option.text || option}</p>
              </div>

            </div>
          );
        })}
      </div>


      {showResults && (
        <div className="learn-trivia-result">
          <div className="learn-explanation">
            <strong>Explanation:</strong> {trivia.explanation}
          </div>
        </div>
      )}
    </div>
  );
}